import { createContext, useContext } from 'react';

/**
 * Resolves {{binding}} tokens in presentation copy against the current
 * proposal (src/domain/bindings.ts). Display paths and editor drafts both
 * resolve so people always work with the text visible on the slide.
 */
export const BindingsContext = createContext<(text: string) => string>((text) => text);

export function useBindings(): (text: string) => string {
  return useContext(BindingsContext);
}
